module.exports = __webpack_public_path__ + "static/media/infantil.fce49333.jpg";